export default {
  actions: {
    salesOrderList(ctx) {
      ctx.commit('updateSalesOrderList', [])
    },
    salesOrderDirectories(ctx) {
      ctx.commit('updateSalesOrderDirectories', null)
    }
  },
  mutations: {
    updateSalesOrderList(state, list) {
      state.salesOrderList = list
    },
    updateSalesOrderDirectories(state, directories) {
      state.salesOrderDirectories = directories
    }
  },
  state: {
    salesOrderList: [],
    salesOrderDirectories: null,
  },
  getters: {
    getSalesOrderList(state) {
      return state.salesOrderList
    },
    getSalesOrderDirectories(state) {
      return state.salesOrderDirectories
    }
  }
}